const OFFICIAL_PRICE_SOURCE =
  "https://www.dmpr.gov.za/Services/Petroleum-Resources/Fuel-Prices";

const CURRENT_PRICES = [
  {
    product: "Petrol 95",
    detail: "ULP & LRP",
    priceType: "Regulated retail",
    inland: 26.1,
    coastal: 25.23,
  },
  {
    product: "Petrol 93",
    detail: "ULP & LRP",
    priceType: "Regulated retail",
    inland: 25.94,
    coastal: 25.07,
  },
  {
    product: "Diesel 500ppm",
    detail: "0.05% sulphur",
    priceType: "Wholesale",
    inland: 24.79,
    coastal: 23.92,
  },
  {
    product: "Diesel 50ppm",
    detail: "0.005% sulphur",
    priceType: "Wholesale",
    inland: 25.17,
    coastal: 24.3,
  },
  {
    product: "Illuminating paraffin",
    detail: "Bulk supply",
    priceType: "Wholesale",
    inland: 17.24,
    coastal: 16.19,
  },
] as const;

function formatPrice(value: number): string {
  return `R${value.toFixed(2)}`;
}

export function CurrentPricesSection() {
  return (
    <section
      className="current-prices-section"
      id="current-prices"
      aria-labelledby="current-prices-heading"
    >
      <header className="current-prices-heading">
        <div>
          <span className="eyebrow">Official DMPR schedule</span>
          <h2 id="current-prices-heading">Current fuel prices</h2>
          <p>
            Effective 1 July through 4 August 2026. Compare the official inland
            and coastal reference prices before viewing the next adjustment forecast.
          </p>
        </div>
        <a href={OFFICIAL_PRICE_SOURCE} target="_blank" rel="noreferrer">
          View official schedule <span aria-hidden="true">↗</span>
        </a>
      </header>

      <div className="current-prices-card">
        <div className="price-schedule-meta">
          <span><span className="live-dot" /> Current schedule</span>
          <span>Inland: Gauteng Zone 9C</span>
          <span>Coastal: Zone 1A</span>
          <span>Rand per litre</span>
        </div>

        <div className="current-price-table-wrap" tabIndex={0}>
          <table className="current-price-table">
            <caption>Official South African fuel prices effective 1 July 2026</caption>
            <thead>
              <tr>
                <th scope="col">Fuel product</th>
                <th scope="col">Price type</th>
                <th scope="col">Inland</th>
                <th scope="col">Coastal</th>
              </tr>
            </thead>
            <tbody>
              {CURRENT_PRICES.map((price) => (
                <tr key={price.product}>
                  <th scope="row">
                    <strong>{price.product}</strong>
                    <span>{price.detail}</span>
                  </th>
                  <td><span className="price-type">{price.priceType}</span></td>
                  <td data-label="Inland"><strong>{formatPrice(price.inland)}</strong><small>/ litre</small></td>
                  <td data-label="Coastal"><strong>{formatPrice(price.coastal)}</strong><small>/ litre</small></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="current-price-notes">
          <p>
            <strong>Petrol</strong> is the regulated retail pump price. Diesel and
            illuminating paraffin are official wholesale benchmarks, so retailer
            pump prices can differ.
          </p>
          <p>
            <strong>Paraffin maximum retail:</strong> R22.18/litre countrywide.
            Prices can vary in other magisterial pricing zones because of transport costs.
          </p>
        </div>
      </div>
    </section>
  );
}
